<template>
  <div class="home sub-menu sub-menu-small h-auto">
    <menu-item
      v-for="item in menuItems"
      :key="item.name"
      :menu-item="item"
      :expiry-flag="expiryFlag"
    ></menu-item>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MenuItem from "./MenuItem.vue";
import * as Menus from "../../common/menus";

export default {
  props: {
    //page name for which menu is to be generated
    pageName: {
      type: String,
      default: ""
    },
    expiryFlag: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      //list of all menu items of page
      menuItems: Menus[this.pageName],
      adminUser: undefined
    };
  },
  components: {
    //component to add menu item dynamically to page menu
    MenuItem
  },
  computed: {
    //to get user credentials to filter access to menu items
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getAccessMode"])
  },
  methods: {
    //checks if user is permitted to view item
    isPermitted(item) {
      let userCredentials = this.getUser.credentials;
      let userAccess = this.getAccessMode;
      let itemPermission = item.permissions.find(element => {
        return element === userCredentials;
      });
      let itemAccess = item.permissions.find(element => {
        if (userAccess === "nbe")
          return element === "user" || element === "smith" || element === "nbe";
        if (userAccess === "smith")
          return element === "user" || element === "smith";
        if (userAccess === "user") return element === "user";
      });
      return itemPermission && itemAccess ? true : false;
    },
    //filters menu items list on basis of credentials (full, readonly)
    filterMenuItems() {
      let register = localStorage.getItem("userRegistered");
      this.menuItems.forEach(item => {
        let ind = this.menuItems.findIndex(row => row.path === "/register");
        if (ind >= 0) {
          let reisterMenu = [];
          if (register === "true") {
            reisterMenu = this.menuItems.filter(
              row => row.path !== "/register"
            );
          } else {
            reisterMenu = this.menuItems.filter(
              row => row.path !== "/system/settings"
            );
          }
          this.menuItems = reisterMenu;
        }

        // eliminate menu item when payment is disabled or not an admin user
        // if (this.expiryFlag === 3 || this.adminUser === "0") {
        //   let excludePayment = this.menuItems.filter(
        //     row => row.path !== "/system/payment-administration"
        //   );
        //   this.menuItems = excludePayment;
        // }
        if (!this.isPermitted(item)) {
          // this.menuItems.splice(this.menuItems.indexOf(item), 1);
          const menu = this.menuItems.filter(row => row.label !== item.label);
          this.menuItems = menu;
        }
      });
    }
  },
  async created() {
    if (this.pageName === "mobile") {
      this.menuItems = [];
      Object.keys(Menus).forEach(element => {
        this.menuItems = this.menuItems.concat(Menus[element]);
        // console.log('Menus: ', element, Menus[element], this.menuItems );
      });
    }
    this.adminUser = localStorage.getItem("adminUser");
    await this.filterMenuItems();
  }
};
</script>

<style>
.home.sub-menu {
  max-height: 125px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sub-menu-small .v-image .v-image__image {
  max-width: 44px !important;
  max-height: 44px;
}
.sub-menu-small .v-btn {
  min-width: 60px;
  text-transform: capitalize;
}
</style>
